import React from "react";

interface Props {
  children: any;
}

export default function index({ children }: Props) {
  return <div>{children}</div>;
}
